export default __webpack_public_path__ + "static/media/digital-lab-logo.a8332850.svg";